module.exports = __webpack_public_path__ + "img/Glassmorphism.3fe504b6.png";